(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
    (function(){
      var btn = document.getElementById('CollectionDescriptionToggle');
      var container = btn && btn.parentNode;
      if(!btn || !container) return;
      btn.addEventListener('click', function(){
        var open = container.classList.toggle('collection-description--open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        btn.querySelector('.collection-description--label').textContent = open ? 'Show less' : 'Read more';
      });
    })();
    
  } catch(e) { console.error(e); }
})();
})();
